<template>
  <v-container v-if="status == 'loading'" fluid fill-height>
    <v-layout align-center justify-center fill-height>
      <v-progress-circular indeterminate></v-progress-circular>
    </v-layout>
  </v-container>
  <v-container fill-height v-else>
    <v-layout align-center justify-center fill-height row>
      <v-flex xs12 sm8>
        <!-- <p>{{swstatus}}</p>
        <p>{{status}}</p>-->

        <v-card v-if="status == 'device-ready'">
          <v-card-title class="headline">
            {{$t('system.update.device-ready')}}
            <v-spacer></v-spacer>
            <v-icon color="green">done</v-icon>
          </v-card-title>
        </v-card>
        <v-card v-if="status == 'wait-device'">
          <v-card-title class="headline">
            {{$t('system.update.waiting-device')}}
            <v-spacer></v-spacer>
            <v-progress-circular indeterminate></v-progress-circular>
          </v-card-title>
          <v-card-text>{{$t('system.update.waiting-detail')}}</v-card-text>
        </v-card>

        <v-card v-if="status == 'error'">
          <v-card-title class="headline">{{$t('system.update.error')}}</v-card-title>
          <v-card-text>{{$t('system.update.error-detail')}}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="reboot">
              Reboot
              <v-icon>refresh</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-card v-if="status == 'up-to-date'">
          <v-card-title class="headline">
            {{$t('system.update.up-to-date')}}
            <v-spacer></v-spacer>
            <v-icon color="green">done</v-icon>
          </v-card-title>
          <v-card-text>{{$t('system.update.up-to-date-description', {sw: user.sw})}}</v-card-text>
        </v-card>

        <v-card v-if="status == 'update-available'">
          <v-card-title class="headline">{{$t('system.update.update-available')}}</v-card-title>
          <v-card-text>{{$t('system.update.update-available-at-url', {url: url})}}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="startUpdate">
              {{$t('system.update.start-upgrade')}}
              <v-icon>play_arrow</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>

        <v-card v-if="status == 'running' || status == 'reboot-ready'">
          <v-card-title class="headline">
            {{status == 'running' ? $t('system.update.upgrading') : $t('system.update.completed-with-success')}}
            <v-spacer></v-spacer>
            <v-progress-circular v-if="status == 'running'" indeterminate></v-progress-circular>
            <v-icon v-if="status == 'reboot-ready'" color="green">done</v-icon>
          </v-card-title>
          <v-card-text>
            <v-list>
              <v-list-tile avatar v-for="item in details" :key="item.section">
                <!-- <v-list-tile-action>
                  <v-icon v-if="item.icon">{{item.icon}}</v-icon>
                </v-list-tile-action>-->
                <v-list-tile-content>
                  <v-list-tile-title>{{$t(item.title)}}</v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-avatar>
                  <v-progress-circular
                    v-if="item.section == 'download_info'"
                    :value="item.progress"
                  ></v-progress-circular>
                  <v-icon v-else :color="item.color ? item.color : 'grey'">{{item.icon}}</v-icon>
                </v-list-tile-avatar>
              </v-list-tile>
            </v-list>
          </v-card-text>
          <v-card-actions>
            <v-dialog
              v-model="showDetails"
              scrollable
              fullscreen
              persistent
              :overlay="false"
              max-width="500px"
              transition="dialog-transition"
            >
              <template v-slot:activator="{ on }">
                <v-btn v-on="on">{{$t('system.update.show-details')}}</v-btn>
              </template>
              <v-card>
                <v-card-title
                  primary-title
                  class="headline grey lighten-2"
                >{{$t('system.update.title-details')}}</v-card-title>
                <v-card-text>
                  <p v-for="msg in msgs" :key="msg">{{msg}}</p>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-btn @click="showDetails = false">{{$t('close')}}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-spacer></v-spacer>
            <v-btn @click="reboot" v-if="status == 'reboot-ready'">
              Reboot
              <v-icon>refresh</v-icon>
            </v-btn>
          </v-card-actions>
          <!-- <v-progress-circular v-if="section == 'download_info'" :value="progress"></v-progress-circular> -->
          <!-- <v-expansion-panel>
            <v-expansion-panel-content>
              <template v-slot:header>
                <v-card-text>{{$t('system.update.details')}}</v-card-text>
              </template>
              <p v-for="msg in msgs" :key="msg">{{msg}}</p>
            </v-expansion-panel-content>
          </v-expansion-panel>-->
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import ApiService from "@/common/api.service";
import Vue from "vue";

const STATUS_IDLE = "0";
const STATUS_START = "1";
const STATUS_RUN = "2";
const STATUS_SUCCESS = "3";
const STATUS_FAILURE = "4";
const STATUS_DOWNLOAD = "5";
const STATUS_DONE = "6";
const STATUS_SUBPROCESS = "7";

export default {
  name: "SWUpdatePage",
  data: () => ({
    showDetails: false,
    loading: false,
    swstatus: null,
    status: "loading",
    progress: null,
    details: [],
    msgs: [],
    url: null
  }),
  computed: {
    ...mapState("auth", ["user"])
  },
  methods: {
    test() {
      ApiService.test(2000)
        .then(() => {
          this.status = "device-ready";
        })
        .catch(() => {
          this.waitDevice(2000);
        });
    },
    addStep(step) {
      this.details.forEach(item => {
        item.icon = "done";
        item.color = "green";
      });
      this.details.push(step);
    },
    postMessage(msg, error = false) {
      this.msgs.push(msg);
      let re = /^\[([a-z_]+)\] : (.*)/;
      let matches = re.exec(msg);
      console.log(matches);
      if (error) {
        this.addStep({
          title: msg,
          section: msg,
          icon: "danger"
        });
      }
      if (matches && matches.length == 3) {
        let section = matches[1];

        let message = matches[2];
        const found = this.details.find(element => element.section == section);
        switch (section) {
          case "install_single_image":
            if (!found) {
              this.addStep({
                title: "system.update.installing",
                section: section,
                icon: "star"
              });
            }
            break;
          case "download_info":
            {
              let redi = /Received : (\d+) \/ (\d+)/;
              let redimatches = redi.exec(message);
              if (redimatches.length == 3) {
                this.progress = parseInt(
                  (100 * redimatches[1]) / redimatches[2]
                );
                if (!found) {
                  this.addStep({
                    title: "system.update.downloading",
                    section: section,
                    icon: "star",
                    progress: this.progress
                  });
                } else {
                  found.progress = this.progress;
                }
              }
            }
            break;
        }
      }
    },
    askstatus() {
      var status;
      var lastStatus;
      var listempty;
      var msg = "";
      var lasterror = 0;
      console.log("Check for swupdate status");
      ApiService.query("/update/swstatus").then(result => {
        let data = result.data.status;
        if (!data) {
          this.poll(500);
          return;
        }
        this.swstatus = data;
        console.log("swupdate status: ", data);
        for (const [key, val] of Object.entries(data)) {
          if (key == "Status") status = val;
          if (key == "LastResult") lastStatus = val;
          if (key == "Msg" && val != "") msg = val;
          if (key == "Error") lasterror = val;
        }
        if (msg) {
          if (lasterror == 0) this.postMessage(msg);
          else this.postMessage(msg, true);
        }
        console.log(status, lastStatus);
        if (status == STATUS_RUN) {
          this.status = "running";
        }
        if (status == STATUS_SUCCESS) {
          console.log("*************** SUCCESS *************");
          console.log("*************** SUCCESS *************");
          console.log("*************** SUCCESS *************");
          console.log("*************** SUCCESS *************");
          console.log("*************** SUCCESS *************");
          this.addStep({
            title: "system.update.completed-with-success",
            section: "completed",
            icon: "done"
          });
        }
        if (status == STATUS_IDLE) {
          if (lastStatus == STATUS_SUCCESS) {
            this.status = "reboot-ready";
            this.addStep({
              title: "system.update.please-reboot",
              section: "reboot",
              icon: "refresh",
              progress: this.progress
            });
          } else if (lastStatus == STATUS_IDLE) {
            this.checkForUpdate();
          } else if (lastStatus == STATUS_FAILURE) {
            this.status = "error";
            return;
          }

          return;
        }
        if (msg) this.poll(50);
        else this.poll(500);
      });
    },
    poll(timer) {
      setTimeout(() => {
        this.askstatus();
      }, timer);
    },
    waitDevice(timer) {
      setTimeout(() => {
        this.test();
      }, timer);
    },

    startUpdate() {
      ApiService.post("/update/", {
        request: "swstart",
        url: this.url
      }).then(result => {
        this.poll(1000);
      });
    },
    reboot() {
      ApiService.post("/update/", {
        request: "swrestart"
      }).then(result => {
        this.status = "wait-device";
        this.waitDevice(5000);
      });
    },
    checkForUpdate() {
      Vue.axios
        .post("http://update.farfisa.com/swupdate/", {
          hw: this.user.hw,
          sw: this.user.sw,
          sn: this.user.sn
        })
        .then(result => {
          if ("url" in result.data) {
            this.status = "update-available";
            this.url = result.data.url;
          } else {
            this.status = "up-to-date";
          }
        })
        .catch(() => {
          this.status = "error";
        });
    }

    /*
    checkForRunningUpdate() {
      this.status = "checking-for-running-update";
      this.askstatus();
      return;
      ApiService.query("/update/swstatus").then(result => {
        let status = result.data.status;
        this.swstatus = status;
        this.status = "checking-for-update";
        if (status.Status == STATUS_IDLE) {
          if (status.LastResult == STATUS_SUCCESS) {
            this.status = "reboot-ready";
          } else {
            Vue.axios
              .post("http://update.farfisa.com/swupdate/", {
                hw: this.user.hw,
                sw: this.user.sw,
                sn: this.user.sn
              })
              .then(result => {
                if ("url" in result.data) {
                  this.status = "update-available";
                  this.url = result.data.url;
                } else {
                  this.status = "no-update-available";
                }
              })
              .catch(() => {
                this.status = "error";
              });
          }
        } else {
          this.poll(1000);
          this.status = "Status: " + status.Status;
        }
      });
    }*/
  },
  mounted() {
    this.askstatus();
    // this.postMessage("[downkia_mio] : Softoware updatei");
    // var value = 0;
    // setInterval(() => {
    //   this.postMessage(`[download_info] : Received : ${value} / 1234567`)
    //   value = value + 10000;
    // }, 200);
    // if (false) {
    //   this.status = "running";
    //   this.postMessage(`[download_info] : Received : 5000 / 1234567`);
    //   setTimeout(() => {
    //     this.postMessage(`[download_info] : Received : 50000 / 1234567`);
    //   }, 2000);
    //   setTimeout(() => {
    //     this.postMessage(`[download_info] : Received : 500000 / 1234567`);
    //   }, 3000);
    //   setTimeout(() => {
    //     this.postMessage(`[download_info] : Received : 1000000 / 1234567`);
    //   }, 4000);
    //   setTimeout(() => {
    //     this.postMessage(`[install_single_image] : Some Other message`);
    //   }, 4500);
    // }
  }
};
</script>

<style scoped>
</style>